import React, { useContext, useEffect } from 'react'
import styles from '../../styles.module.css'
import LanguageContext from '../../contexts/languageContext'
import { getLanguageFromUrl } from '../../utils/navigation'
import ErrorImg from '../../../static/assets/error_icon.svg'

const NotFoundLayout = ({ location, children }) => {
  const { setLanguage } = useContext(LanguageContext)

  useEffect(() => {
    setLanguage(getLanguageFromUrl(location.pathname))
  }, [setLanguage, location.pathname])

  return (
    <div className={styles.errorContainer} data-cy="404-page">
      <div className={styles.errorContent}>
        <ErrorImg className={styles.errorImg} />
        <div className={styles.errorMessage}>{children}</div>
      </div>
    </div>
  )
}

export default NotFoundLayout
